import * as Apollo from '@apollo/client';
import { gql } from '@apollo/client';

function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
function _arrayWithHoles(r) {
  if (Array.isArray(r)) return r;
}
function _arrayWithoutHoles(r) {
  if (Array.isArray(r)) return _arrayLikeToArray(r);
}
function asyncGeneratorStep(n, t, e, r, o, a, c) {
  try {
    var i = n[a](c),
      u = i.value;
  } catch (n) {
    return void e(n);
  }
  i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function _asyncToGenerator(n) {
  return function () {
    var t = this,
      e = arguments;
    return new Promise(function (r, o) {
      var a = n.apply(t, e);
      function _next(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
      }
      function _throw(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
      }
      _next(void 0);
    });
  };
}
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}
function _iterableToArray(r) {
  if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}
function _iterableToArrayLimit(r, l) {
  var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (null != t) {
    var e,
      n,
      i,
      u,
      a = [],
      f = !0,
      o = !1;
    try {
      if (i = (t = t.call(r)).next, 0 === l) {
        if (Object(t) !== t) return;
        f = !1;
      } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
    } catch (r) {
      o = !0, n = r;
    } finally {
      try {
        if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return;
      } finally {
        if (o) throw n;
      }
    }
    return a;
  }
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread2(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function _objectWithoutProperties(e, t) {
  if (null == e) return {};
  var o,
    r,
    i = _objectWithoutPropertiesLoose(e, t);
  if (Object.getOwnPropertySymbols) {
    var s = Object.getOwnPropertySymbols(e);
    for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
  }
  return i;
}
function _objectWithoutPropertiesLoose(r, e) {
  if (null == r) return {};
  var t = {};
  for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
    if (e.includes(n)) continue;
    t[n] = r[n];
  }
  return t;
}
function _regeneratorRuntime() {
  _regeneratorRuntime = function () {
    return e;
  };
  var t,
    e = {},
    r = Object.prototype,
    n = r.hasOwnProperty,
    o = Object.defineProperty || function (t, e, r) {
      t[e] = r.value;
    },
    i = "function" == typeof Symbol ? Symbol : {},
    a = i.iterator || "@@iterator",
    c = i.asyncIterator || "@@asyncIterator",
    u = i.toStringTag || "@@toStringTag";
  function define(t, e, r) {
    return Object.defineProperty(t, e, {
      value: r,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }), t[e];
  }
  try {
    define({}, "");
  } catch (t) {
    define = function (t, e, r) {
      return t[e] = r;
    };
  }
  function wrap(t, e, r, n) {
    var i = e && e.prototype instanceof Generator ? e : Generator,
      a = Object.create(i.prototype),
      c = new Context(n || []);
    return o(a, "_invoke", {
      value: makeInvokeMethod(t, r, c)
    }), a;
  }
  function tryCatch(t, e, r) {
    try {
      return {
        type: "normal",
        arg: t.call(e, r)
      };
    } catch (t) {
      return {
        type: "throw",
        arg: t
      };
    }
  }
  e.wrap = wrap;
  var h = "suspendedStart",
    l = "suspendedYield",
    f = "executing",
    s = "completed",
    y = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  var p = {};
  define(p, a, function () {
    return this;
  });
  var d = Object.getPrototypeOf,
    v = d && d(d(values([])));
  v && v !== r && n.call(v, a) && (p = v);
  var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p);
  function defineIteratorMethods(t) {
    ["next", "throw", "return"].forEach(function (e) {
      define(t, e, function (t) {
        return this._invoke(e, t);
      });
    });
  }
  function AsyncIterator(t, e) {
    function invoke(r, o, i, a) {
      var c = tryCatch(t[r], t, o);
      if ("throw" !== c.type) {
        var u = c.arg,
          h = u.value;
        return h && "object" == typeof h && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) {
          invoke("next", t, i, a);
        }, function (t) {
          invoke("throw", t, i, a);
        }) : e.resolve(h).then(function (t) {
          u.value = t, i(u);
        }, function (t) {
          return invoke("throw", t, i, a);
        });
      }
      a(c.arg);
    }
    var r;
    o(this, "_invoke", {
      value: function (t, n) {
        function callInvokeWithMethodAndArg() {
          return new e(function (e, r) {
            invoke(t, n, e, r);
          });
        }
        return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
      }
    });
  }
  function makeInvokeMethod(e, r, n) {
    var o = h;
    return function (i, a) {
      if (o === f) throw Error("Generator is already running");
      if (o === s) {
        if ("throw" === i) throw a;
        return {
          value: t,
          done: !0
        };
      }
      for (n.method = i, n.arg = a;;) {
        var c = n.delegate;
        if (c) {
          var u = maybeInvokeDelegate(c, n);
          if (u) {
            if (u === y) continue;
            return u;
          }
        }
        if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) {
          if (o === h) throw o = s, n.arg;
          n.dispatchException(n.arg);
        } else "return" === n.method && n.abrupt("return", n.arg);
        o = f;
        var p = tryCatch(e, r, n);
        if ("normal" === p.type) {
          if (o = n.done ? s : l, p.arg === y) continue;
          return {
            value: p.arg,
            done: n.done
          };
        }
        "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg);
      }
    };
  }
  function maybeInvokeDelegate(e, r) {
    var n = r.method,
      o = e.iterator[n];
    if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y;
    var i = tryCatch(o, e.iterator, r.arg);
    if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y;
    var a = i.arg;
    return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y);
  }
  function pushTryEntry(t) {
    var e = {
      tryLoc: t[0]
    };
    1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e);
  }
  function resetTryEntry(t) {
    var e = t.completion || {};
    e.type = "normal", delete e.arg, t.completion = e;
  }
  function Context(t) {
    this.tryEntries = [{
      tryLoc: "root"
    }], t.forEach(pushTryEntry, this), this.reset(!0);
  }
  function values(e) {
    if (e || "" === e) {
      var r = e[a];
      if (r) return r.call(e);
      if ("function" == typeof e.next) return e;
      if (!isNaN(e.length)) {
        var o = -1,
          i = function next() {
            for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next;
            return next.value = t, next.done = !0, next;
          };
        return i.next = i;
      }
    }
    throw new TypeError(typeof e + " is not iterable");
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", {
    value: GeneratorFunctionPrototype,
    configurable: !0
  }), o(GeneratorFunctionPrototype, "constructor", {
    value: GeneratorFunction,
    configurable: !0
  }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) {
    var e = "function" == typeof t && t.constructor;
    return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name));
  }, e.mark = function (t) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t;
  }, e.awrap = function (t) {
    return {
      __await: t
    };
  }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () {
    return this;
  }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) {
    void 0 === i && (i = Promise);
    var a = new AsyncIterator(wrap(t, r, n, o), i);
    return e.isGeneratorFunction(r) ? a : a.next().then(function (t) {
      return t.done ? t.value : a.next();
    });
  }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () {
    return this;
  }), define(g, "toString", function () {
    return "[object Generator]";
  }), e.keys = function (t) {
    var e = Object(t),
      r = [];
    for (var n in e) r.push(n);
    return r.reverse(), function next() {
      for (; r.length;) {
        var t = r.pop();
        if (t in e) return next.value = t, next.done = !1, next;
      }
      return next.done = !0, next;
    };
  }, e.values = values, Context.prototype = {
    constructor: Context,
    reset: function (e) {
      if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t);
    },
    stop: function () {
      this.done = !0;
      var t = this.tryEntries[0].completion;
      if ("throw" === t.type) throw t.arg;
      return this.rval;
    },
    dispatchException: function (e) {
      if (this.done) throw e;
      var r = this;
      function handle(n, o) {
        return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o;
      }
      for (var o = this.tryEntries.length - 1; o >= 0; --o) {
        var i = this.tryEntries[o],
          a = i.completion;
        if ("root" === i.tryLoc) return handle("end");
        if (i.tryLoc <= this.prev) {
          var c = n.call(i, "catchLoc"),
            u = n.call(i, "finallyLoc");
          if (c && u) {
            if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
            if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
          } else if (c) {
            if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
          } else {
            if (!u) throw Error("try statement without catch or finally");
            if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
          }
        }
      }
    },
    abrupt: function (t, e) {
      for (var r = this.tryEntries.length - 1; r >= 0; --r) {
        var o = this.tryEntries[r];
        if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) {
          var i = o;
          break;
        }
      }
      i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null);
      var a = i ? i.completion : {};
      return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a);
    },
    complete: function (t, e) {
      if ("throw" === t.type) throw t.arg;
      return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y;
    },
    finish: function (t) {
      for (var e = this.tryEntries.length - 1; e >= 0; --e) {
        var r = this.tryEntries[e];
        if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y;
      }
    },
    catch: function (t) {
      for (var e = this.tryEntries.length - 1; e >= 0; --e) {
        var r = this.tryEntries[e];
        if (r.tryLoc === t) {
          var n = r.completion;
          if ("throw" === n.type) {
            var o = n.arg;
            resetTryEntry(r);
          }
          return o;
        }
      }
      throw Error("illegal catch attempt");
    },
    delegateYield: function (e, r, n) {
      return this.delegate = {
        iterator: values(e),
        resultName: r,
        nextLoc: n
      }, "next" === this.method && (this.arg = t), y;
    }
  }, e;
}
function _slicedToArray(r, e) {
  return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest();
}
function _taggedTemplateLiteral(e, t) {
  return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, {
    raw: {
      value: Object.freeze(t)
    }
  }));
}
function _toConsumableArray(r) {
  return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread();
}
function _toPrimitive(t, r) {
  if ("object" != typeof t || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != typeof i) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == typeof i ? i : i + "";
}
function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9, _templateObject10, _templateObject11, _templateObject12, _templateObject13, _templateObject14, _templateObject15, _templateObject16, _templateObject17, _templateObject18, _templateObject19, _templateObject20, _templateObject21, _templateObject22, _templateObject23, _templateObject24, _templateObject25, _templateObject26, _templateObject27, _templateObject28, _templateObject29, _templateObject30, _templateObject31, _templateObject32, _templateObject33, _templateObject34, _templateObject35, _templateObject36, _templateObject37, _templateObject38, _templateObject39, _templateObject40, _templateObject41, _templateObject42, _templateObject43, _templateObject44;
var defaultOptions = {};
/** What rating to display avatars up to. Accepts 'G', 'PG', 'R', 'X', and are judged in that order. Default is the value of the 'avatar_rating' option */
var AvatarRatingEnum;
(function (AvatarRatingEnum) {
  /** Indicates a G level avatar rating level. */
  AvatarRatingEnum["G"] = "G";
  /** Indicates a PG level avatar rating level. */
  AvatarRatingEnum["Pg"] = "PG";
  /** Indicates an R level avatar rating level. */
  AvatarRatingEnum["R"] = "R";
  /** Indicates an X level avatar rating level. */
  AvatarRatingEnum["X"] = "X";
})(AvatarRatingEnum || (AvatarRatingEnum = {}));
/** The Type of Identifier used to fetch a single resource. Default is ID. */
var CategoryIdType;
(function (CategoryIdType) {
  /** The Database ID for the node */
  CategoryIdType["DatabaseId"] = "DATABASE_ID";
  /** The hashed Global ID */
  CategoryIdType["Id"] = "ID";
  /** The name of the node */
  CategoryIdType["Name"] = "NAME";
  /** Url friendly name of the node */
  CategoryIdType["Slug"] = "SLUG";
  /** The URI for the node */
  CategoryIdType["Uri"] = "URI";
})(CategoryIdType || (CategoryIdType = {}));
/** The Type of Identifier used to fetch a single resource. Default is ID. */
var CollectionIdType;
(function (CollectionIdType) {
  /** Identify a resource by the Database ID. */
  CollectionIdType["DatabaseId"] = "DATABASE_ID";
  /** Identify a resource by the (hashed) Global ID. */
  CollectionIdType["Id"] = "ID";
  /** Identify a resource by the slug. Available to non-hierarchcial Types where the slug is a unique identifier. */
  CollectionIdType["Slug"] = "SLUG";
  /** Identify a resource by the URI. */
  CollectionIdType["Uri"] = "URI";
})(CollectionIdType || (CollectionIdType = {}));
/** The Type of Identifier used to fetch a single comment node. Default is "ID". To be used along with the "id" field. */
var CommentNodeIdTypeEnum;
(function (CommentNodeIdTypeEnum) {
  /** Identify a resource by the Database ID. */
  CommentNodeIdTypeEnum["DatabaseId"] = "DATABASE_ID";
  /** Identify a resource by the (hashed) Global ID. */
  CommentNodeIdTypeEnum["Id"] = "ID";
})(CommentNodeIdTypeEnum || (CommentNodeIdTypeEnum = {}));
/** The status of the comment object. */
var CommentStatusEnum;
(function (CommentStatusEnum) {
  /** Comments with the Hyväksytty status */
  CommentStatusEnum["Approve"] = "APPROVE";
  /** Comments with the Hylätyt status */
  CommentStatusEnum["Hold"] = "HOLD";
  /** Comments with the Roskaviesti status */
  CommentStatusEnum["Spam"] = "SPAM";
  /** Comments with the Roskakorissa status */
  CommentStatusEnum["Trash"] = "TRASH";
})(CommentStatusEnum || (CommentStatusEnum = {}));
/** Options for ordering the connection */
var CommentsConnectionOrderbyEnum;
(function (CommentsConnectionOrderbyEnum) {
  /** Order by browser user agent of the commenter. */
  CommentsConnectionOrderbyEnum["CommentAgent"] = "COMMENT_AGENT";
  /** Order by approval status of the comment. */
  CommentsConnectionOrderbyEnum["CommentApproved"] = "COMMENT_APPROVED";
  /** Order by name of the comment author. */
  CommentsConnectionOrderbyEnum["CommentAuthor"] = "COMMENT_AUTHOR";
  /** Order by e-mail of the comment author. */
  CommentsConnectionOrderbyEnum["CommentAuthorEmail"] = "COMMENT_AUTHOR_EMAIL";
  /** Order by IP address of the comment author. */
  CommentsConnectionOrderbyEnum["CommentAuthorIp"] = "COMMENT_AUTHOR_IP";
  /** Order by URL address of the comment author. */
  CommentsConnectionOrderbyEnum["CommentAuthorUrl"] = "COMMENT_AUTHOR_URL";
  /** Order by the comment contents. */
  CommentsConnectionOrderbyEnum["CommentContent"] = "COMMENT_CONTENT";
  /** Order by date/time timestamp of the comment. */
  CommentsConnectionOrderbyEnum["CommentDate"] = "COMMENT_DATE";
  /** Order by GMT timezone date/time timestamp of the comment. */
  CommentsConnectionOrderbyEnum["CommentDateGmt"] = "COMMENT_DATE_GMT";
  /** Order by the globally unique identifier for the comment object */
  CommentsConnectionOrderbyEnum["CommentId"] = "COMMENT_ID";
  /** Order by the array list of comment IDs listed in the where clause. */
  CommentsConnectionOrderbyEnum["CommentIn"] = "COMMENT_IN";
  /** Order by the comment karma score. */
  CommentsConnectionOrderbyEnum["CommentKarma"] = "COMMENT_KARMA";
  /** Order by the comment parent ID. */
  CommentsConnectionOrderbyEnum["CommentParent"] = "COMMENT_PARENT";
  /** Order by the post object ID. */
  CommentsConnectionOrderbyEnum["CommentPostId"] = "COMMENT_POST_ID";
  /** Order by the the type of comment, such as 'comment', 'pingback', or 'trackback'. */
  CommentsConnectionOrderbyEnum["CommentType"] = "COMMENT_TYPE";
  /** Order by the user ID. */
  CommentsConnectionOrderbyEnum["UserId"] = "USER_ID";
})(CommentsConnectionOrderbyEnum || (CommentsConnectionOrderbyEnum = {}));
/** The Type of Identifier used to fetch a single resource. Default is ID. */
var ContactIdType;
(function (ContactIdType) {
  /** Identify a resource by the Database ID. */
  ContactIdType["DatabaseId"] = "DATABASE_ID";
  /** Identify a resource by the (hashed) Global ID. */
  ContactIdType["Id"] = "ID";
  /** Identify a resource by the slug. Available to non-hierarchcial Types where the slug is a unique identifier. */
  ContactIdType["Slug"] = "SLUG";
  /** Identify a resource by the URI. */
  ContactIdType["Uri"] = "URI";
})(ContactIdType || (ContactIdType = {}));
/** The Type of Identifier used to fetch a single resource. Default is ID. */
var ContentNodeIdTypeEnum;
(function (ContentNodeIdTypeEnum) {
  /** Identify a resource by the Database ID. */
  ContentNodeIdTypeEnum["DatabaseId"] = "DATABASE_ID";
  /** Identify a resource by the (hashed) Global ID. */
  ContentNodeIdTypeEnum["Id"] = "ID";
  /** Identify a resource by the URI. */
  ContentNodeIdTypeEnum["Uri"] = "URI";
})(ContentNodeIdTypeEnum || (ContentNodeIdTypeEnum = {}));
/** Allowed Content Types */
var ContentTypeEnum;
(function (ContentTypeEnum) {
  /** The Type of Content object */
  ContentTypeEnum["Attachment"] = "ATTACHMENT";
  /** The Type of Content object */
  ContentTypeEnum["CollectionCpt"] = "COLLECTION_CPT";
  /** The Type of Content object */
  ContentTypeEnum["ContactCpt"] = "CONTACT_CPT";
  /** The Type of Content object */
  ContentTypeEnum["LandingPageCpt"] = "LANDING_PAGE_CPT";
  /** The Type of Content object */
  ContentTypeEnum["Page"] = "PAGE";
  /** The Type of Content object */
  ContentTypeEnum["Post"] = "POST";
  /** The Type of Content object */
  ContentTypeEnum["ReleaseCpt"] = "RELEASE_CPT";
  /** The Type of Content object */
  ContentTypeEnum["TranslationCpt"] = "TRANSLATION_CPT";
})(ContentTypeEnum || (ContentTypeEnum = {}));
/** The Type of Identifier used to fetch a single Content Type node. To be used along with the "id" field. Default is "ID". */
var ContentTypeIdTypeEnum;
(function (ContentTypeIdTypeEnum) {
  /** The globally unique ID */
  ContentTypeIdTypeEnum["Id"] = "ID";
  /** The name of the content type. */
  ContentTypeIdTypeEnum["Name"] = "NAME";
})(ContentTypeIdTypeEnum || (ContentTypeIdTypeEnum = {}));
/** Allowed Content Types of the Category taxonomy. */
var ContentTypesOfCategoryEnum;
(function (ContentTypesOfCategoryEnum) {
  /** The Type of Content object */
  ContentTypesOfCategoryEnum["Post"] = "POST";
})(ContentTypesOfCategoryEnum || (ContentTypesOfCategoryEnum = {}));
/** Allowed Content Types of the PostFormat taxonomy. */
var ContentTypesOfPostFormatEnum;
(function (ContentTypesOfPostFormatEnum) {
  /** The Type of Content object */
  ContentTypesOfPostFormatEnum["Post"] = "POST";
})(ContentTypesOfPostFormatEnum || (ContentTypesOfPostFormatEnum = {}));
/** Allowed Content Types of the Tag taxonomy. */
var ContentTypesOfTagEnum;
(function (ContentTypesOfTagEnum) {
  /** The Type of Content object */
  ContentTypesOfTagEnum["Post"] = "POST";
})(ContentTypesOfTagEnum || (ContentTypesOfTagEnum = {}));
/** The Type of Identifier used to fetch a single resource. Default is ID. */
var LandingPageIdType;
(function (LandingPageIdType) {
  /** Identify a resource by the Database ID. */
  LandingPageIdType["DatabaseId"] = "DATABASE_ID";
  /** Identify a resource by the (hashed) Global ID. */
  LandingPageIdType["Id"] = "ID";
  /** Identify a resource by the slug. Available to non-hierarchcial Types where the slug is a unique identifier. */
  LandingPageIdType["Slug"] = "SLUG";
  /** Identify a resource by the URI. */
  LandingPageIdType["Uri"] = "URI";
})(LandingPageIdType || (LandingPageIdType = {}));
/** Enum of all available language codes */
var LanguageCodeEnum;
(function (LanguageCodeEnum) {
  LanguageCodeEnum["En"] = "EN";
  LanguageCodeEnum["Fi"] = "FI";
  LanguageCodeEnum["Sv"] = "SV";
})(LanguageCodeEnum || (LanguageCodeEnum = {}));
/** Filter item by specific language, default language or list all languages */
var LanguageCodeFilterEnum;
(function (LanguageCodeFilterEnum) {
  LanguageCodeFilterEnum["All"] = "ALL";
  LanguageCodeFilterEnum["Default"] = "DEFAULT";
  LanguageCodeFilterEnum["En"] = "EN";
  LanguageCodeFilterEnum["Fi"] = "FI";
  LanguageCodeFilterEnum["Sv"] = "SV";
})(LanguageCodeFilterEnum || (LanguageCodeFilterEnum = {}));
/** The Type of Identifier used to fetch a single resource. Default is ID. */
var MediaItemIdType;
(function (MediaItemIdType) {
  /** Identify a resource by the Database ID. */
  MediaItemIdType["DatabaseId"] = "DATABASE_ID";
  /** Identify a resource by the (hashed) Global ID. */
  MediaItemIdType["Id"] = "ID";
  /** Identify a resource by the slug. Available to non-hierarchcial Types where the slug is a unique identifier. */
  MediaItemIdType["Slug"] = "SLUG";
  /** Identify a media item by its source url */
  MediaItemIdType["SourceUrl"] = "SOURCE_URL";
  /** Identify a resource by the URI. */
  MediaItemIdType["Uri"] = "URI";
})(MediaItemIdType || (MediaItemIdType = {}));
/** The size of the media item object. */
var MediaItemSizeEnum;
(function (MediaItemSizeEnum) {
  /** MediaItem with the large size */
  MediaItemSizeEnum["Large"] = "LARGE";
  /** MediaItem with the medium size */
  MediaItemSizeEnum["Medium"] = "MEDIUM";
  /** MediaItem with the medium_large size */
  MediaItemSizeEnum["MediumLarge"] = "MEDIUM_LARGE";
  /** MediaItem with the thumbnail size */
  MediaItemSizeEnum["Thumbnail"] = "THUMBNAIL";
  /** MediaItem with the 1536x1536 size */
  MediaItemSizeEnum["1536X1536"] = "_1536X1536";
  /** MediaItem with the 2048x2048 size */
  MediaItemSizeEnum["2048X2048"] = "_2048X2048";
})(MediaItemSizeEnum || (MediaItemSizeEnum = {}));
/** The status of the media item object. */
var MediaItemStatusEnum;
(function (MediaItemStatusEnum) {
  /** Objects with the auto-draft status */
  MediaItemStatusEnum["AutoDraft"] = "AUTO_DRAFT";
  /** Objects with the inherit status */
  MediaItemStatusEnum["Inherit"] = "INHERIT";
  /** Objects with the private status */
  MediaItemStatusEnum["Private"] = "PRIVATE";
  /** Objects with the trash status */
  MediaItemStatusEnum["Trash"] = "TRASH";
})(MediaItemStatusEnum || (MediaItemStatusEnum = {}));
/** The Type of Identifier used to fetch a single node. Default is "ID". To be used along with the "id" field. */
var MenuItemNodeIdTypeEnum;
(function (MenuItemNodeIdTypeEnum) {
  /** Identify a resource by the Database ID. */
  MenuItemNodeIdTypeEnum["DatabaseId"] = "DATABASE_ID";
  /** Identify a resource by the (hashed) Global ID. */
  MenuItemNodeIdTypeEnum["Id"] = "ID";
})(MenuItemNodeIdTypeEnum || (MenuItemNodeIdTypeEnum = {}));
/** Registered menu locations */
var MenuLocationEnum;
(function (MenuLocationEnum) {
  /** Put the menu in the primary location */
  MenuLocationEnum["Primary"] = "PRIMARY";
  /** Put the menu in the primary___en location */
  MenuLocationEnum["PrimaryEn"] = "PRIMARY___EN";
  /** Put the menu in the primary___sv location */
  MenuLocationEnum["PrimarySv"] = "PRIMARY___SV";
  /** Put the menu in the secondary location */
  MenuLocationEnum["Secondary"] = "SECONDARY";
  /** Put the menu in the secondary___en location */
  MenuLocationEnum["SecondaryEn"] = "SECONDARY___EN";
  /** Put the menu in the secondary___sv location */
  MenuLocationEnum["SecondarySv"] = "SECONDARY___SV";
  /** Put the menu in the tertiary location */
  MenuLocationEnum["Tertiary"] = "TERTIARY";
  /** Put the menu in the tertiary___en location */
  MenuLocationEnum["TertiaryEn"] = "TERTIARY___EN";
  /** Put the menu in the tertiary___sv location */
  MenuLocationEnum["TertiarySv"] = "TERTIARY___SV";
})(MenuLocationEnum || (MenuLocationEnum = {}));
/** The Type of Identifier used to fetch a single node. Default is "ID". To be used along with the "id" field. */
var MenuNodeIdTypeEnum;
(function (MenuNodeIdTypeEnum) {
  /** Identify a menu node by the Database ID. */
  MenuNodeIdTypeEnum["DatabaseId"] = "DATABASE_ID";
  /** Identify a menu node by the (hashed) Global ID. */
  MenuNodeIdTypeEnum["Id"] = "ID";
  /** Identify a menu node by the slug of menu location to which it is assigned */
  MenuNodeIdTypeEnum["Location"] = "LOCATION";
  /** Identify a menu node by its name */
  MenuNodeIdTypeEnum["Name"] = "NAME";
  /** Identify a menu node by its slug */
  MenuNodeIdTypeEnum["Slug"] = "SLUG";
})(MenuNodeIdTypeEnum || (MenuNodeIdTypeEnum = {}));
/** The MimeType of the object */
var MimeTypeEnum;
(function (MimeTypeEnum) {
  /** application/msword mime type. */
  MimeTypeEnum["ApplicationMsword"] = "APPLICATION_MSWORD";
  /** application/pdf mime type. */
  MimeTypeEnum["ApplicationPdf"] = "APPLICATION_PDF";
  /** application/vnd.apple.keynote mime type. */
  MimeTypeEnum["ApplicationVndAppleKeynote"] = "APPLICATION_VND_APPLE_KEYNOTE";
  /** application/vnd.ms-excel mime type. */
  MimeTypeEnum["ApplicationVndMsExcel"] = "APPLICATION_VND_MS_EXCEL";
  /** application/vnd.ms-excel.sheet.binary.macroEnabled.12 mime type. */
  MimeTypeEnum["ApplicationVndMsExcelSheetBinaryMacroenabled_12"] = "APPLICATION_VND_MS_EXCEL_SHEET_BINARY_MACROENABLED_12";
  /** application/vnd.ms-excel.sheet.macroEnabled.12 mime type. */
  MimeTypeEnum["ApplicationVndMsExcelSheetMacroenabled_12"] = "APPLICATION_VND_MS_EXCEL_SHEET_MACROENABLED_12";
  /** application/vnd.ms-powerpoint mime type. */
  MimeTypeEnum["ApplicationVndMsPowerpoint"] = "APPLICATION_VND_MS_POWERPOINT";
  /** application/vnd.ms-powerpoint.presentation.macroEnabled.12 mime type. */
  MimeTypeEnum["ApplicationVndMsPowerpointPresentationMacroenabled_12"] = "APPLICATION_VND_MS_POWERPOINT_PRESENTATION_MACROENABLED_12";
  /** application/vnd.ms-powerpoint.slideshow.macroEnabled.12 mime type. */
  MimeTypeEnum["ApplicationVndMsPowerpointSlideshowMacroenabled_12"] = "APPLICATION_VND_MS_POWERPOINT_SLIDESHOW_MACROENABLED_12";
  /** application/vnd.ms-word.document.macroEnabled.12 mime type. */
  MimeTypeEnum["ApplicationVndMsWordDocumentMacroenabled_12"] = "APPLICATION_VND_MS_WORD_DOCUMENT_MACROENABLED_12";
  /** application/vnd.oasis.opendocument.text mime type. */
  MimeTypeEnum["ApplicationVndOasisOpendocumentText"] = "APPLICATION_VND_OASIS_OPENDOCUMENT_TEXT";
  /** application/vnd.openxmlformats-officedocument.presentationml.presentation mime type. */
  MimeTypeEnum["ApplicationVndOpenxmlformatsOfficedocumentPresentationmlPresentation"] = "APPLICATION_VND_OPENXMLFORMATS_OFFICEDOCUMENT_PRESENTATIONML_PRESENTATION";
  /** application/vnd.openxmlformats-officedocument.presentationml.slideshow mime type. */
  MimeTypeEnum["ApplicationVndOpenxmlformatsOfficedocumentPresentationmlSlideshow"] = "APPLICATION_VND_OPENXMLFORMATS_OFFICEDOCUMENT_PRESENTATIONML_SLIDESHOW";
  /** application/vnd.openxmlformats-officedocument.spreadsheetml.sheet mime type. */
  MimeTypeEnum["ApplicationVndOpenxmlformatsOfficedocumentSpreadsheetmlSheet"] = "APPLICATION_VND_OPENXMLFORMATS_OFFICEDOCUMENT_SPREADSHEETML_SHEET";
  /** application/vnd.openxmlformats-officedocument.wordprocessingml.document mime type. */
  MimeTypeEnum["ApplicationVndOpenxmlformatsOfficedocumentWordprocessingmlDocument"] = "APPLICATION_VND_OPENXMLFORMATS_OFFICEDOCUMENT_WORDPROCESSINGML_DOCUMENT";
  /** audio/flac mime type. */
  MimeTypeEnum["AudioFlac"] = "AUDIO_FLAC";
  /** audio/midi mime type. */
  MimeTypeEnum["AudioMidi"] = "AUDIO_MIDI";
  /** audio/mpeg mime type. */
  MimeTypeEnum["AudioMpeg"] = "AUDIO_MPEG";
  /** audio/ogg mime type. */
  MimeTypeEnum["AudioOgg"] = "AUDIO_OGG";
  /** audio/wav mime type. */
  MimeTypeEnum["AudioWav"] = "AUDIO_WAV";
  /** image/avif mime type. */
  MimeTypeEnum["ImageAvif"] = "IMAGE_AVIF";
  /** image/gif mime type. */
  MimeTypeEnum["ImageGif"] = "IMAGE_GIF";
  /** image/jpeg mime type. */
  MimeTypeEnum["ImageJpeg"] = "IMAGE_JPEG";
  /** image/png mime type. */
  MimeTypeEnum["ImagePng"] = "IMAGE_PNG";
  /** video/3gpp mime type. */
  MimeTypeEnum["Video_3Gpp"] = "VIDEO_3GPP";
  /** video/3gpp2 mime type. */
  MimeTypeEnum["Video_3Gpp2"] = "VIDEO_3GPP2";
  /** video/avi mime type. */
  MimeTypeEnum["VideoAvi"] = "VIDEO_AVI";
  /** video/mp4 mime type. */
  MimeTypeEnum["VideoMp4"] = "VIDEO_MP4";
  /** video/mpeg mime type. */
  MimeTypeEnum["VideoMpeg"] = "VIDEO_MPEG";
  /** video/ogg mime type. */
  MimeTypeEnum["VideoOgg"] = "VIDEO_OGG";
  /** video/quicktime mime type. */
  MimeTypeEnum["VideoQuicktime"] = "VIDEO_QUICKTIME";
  /** video/webm mime type. */
  MimeTypeEnum["VideoWebm"] = "VIDEO_WEBM";
  /** video/x-flv mime type. */
  MimeTypeEnum["VideoXFlv"] = "VIDEO_X_FLV";
})(MimeTypeEnum || (MimeTypeEnum = {}));
/** The cardinality of the connection order */
var OrderEnum;
(function (OrderEnum) {
  /** Sort the query result set in an ascending order */
  OrderEnum["Asc"] = "ASC";
  /** Sort the query result set in a descending order */
  OrderEnum["Desc"] = "DESC";
})(OrderEnum || (OrderEnum = {}));
/** The Type of Identifier used to fetch a single resource. Default is ID. */
var PageIdType;
(function (PageIdType) {
  /** Identify a resource by the Database ID. */
  PageIdType["DatabaseId"] = "DATABASE_ID";
  /** Identify a resource by the (hashed) Global ID. */
  PageIdType["Id"] = "ID";
  /** Identify a resource by the URI. */
  PageIdType["Uri"] = "URI";
})(PageIdType || (PageIdType = {}));
/** The status of the WordPress plugin. */
var PluginStatusEnum;
(function (PluginStatusEnum) {
  /** The plugin is currently active. */
  PluginStatusEnum["Active"] = "ACTIVE";
  /** The plugin is a drop-in plugin. */
  PluginStatusEnum["DropIn"] = "DROP_IN";
  /** The plugin is currently inactive. */
  PluginStatusEnum["Inactive"] = "INACTIVE";
  /** The plugin is a must-use plugin. */
  PluginStatusEnum["MustUse"] = "MUST_USE";
  /** The plugin is activated on the multisite network. */
  PluginStatusEnum["NetworkActivated"] = "NETWORK_ACTIVATED";
  /** The plugin is installed on the multisite network, but is currently inactive. */
  PluginStatusEnum["NetworkInactive"] = "NETWORK_INACTIVE";
  /** The plugin is technically active but was paused while loading. */
  PluginStatusEnum["Paused"] = "PAUSED";
  /** The plugin was active recently. */
  PluginStatusEnum["RecentlyActive"] = "RECENTLY_ACTIVE";
  /** The plugin has an upgrade available. */
  PluginStatusEnum["Upgrade"] = "UPGRADE";
})(PluginStatusEnum || (PluginStatusEnum = {}));
/** The Type of Identifier used to fetch a single resource. Default is ID. */
var PostFormatIdType;
(function (PostFormatIdType) {
  /** The Database ID for the node */
  PostFormatIdType["DatabaseId"] = "DATABASE_ID";
  /** The hashed Global ID */
  PostFormatIdType["Id"] = "ID";
  /** The name of the node */
  PostFormatIdType["Name"] = "NAME";
  /** Url friendly name of the node */
  PostFormatIdType["Slug"] = "SLUG";
  /** The URI for the node */
  PostFormatIdType["Uri"] = "URI";
})(PostFormatIdType || (PostFormatIdType = {}));
/** The Type of Identifier used to fetch a single resource. Default is ID. */
var PostIdType;
(function (PostIdType) {
  /** Identify a resource by the Database ID. */
  PostIdType["DatabaseId"] = "DATABASE_ID";
  /** Identify a resource by the (hashed) Global ID. */
  PostIdType["Id"] = "ID";
  /** Identify a resource by the slug. Available to non-hierarchcial Types where the slug is a unique identifier. */
  PostIdType["Slug"] = "SLUG";
  /** Identify a resource by the URI. */
  PostIdType["Uri"] = "URI";
})(PostIdType || (PostIdType = {}));
/** The format of post field data. */
var PostObjectFieldFormatEnum;
(function (PostObjectFieldFormatEnum) {
  /** Provide the field value directly from database. Null on unauthenticated requests. */
  PostObjectFieldFormatEnum["Raw"] = "RAW";
  /** Provide the field value as rendered by WordPress. Default. */
  PostObjectFieldFormatEnum["Rendered"] = "RENDERED";
})(PostObjectFieldFormatEnum || (PostObjectFieldFormatEnum = {}));
/** The column to use when filtering by date */
var PostObjectsConnectionDateColumnEnum;
(function (PostObjectsConnectionDateColumnEnum) {
  /** The date the comment was created in local time. */
  PostObjectsConnectionDateColumnEnum["Date"] = "DATE";
  /** The most recent modification date of the comment. */
  PostObjectsConnectionDateColumnEnum["Modified"] = "MODIFIED";
})(PostObjectsConnectionDateColumnEnum || (PostObjectsConnectionDateColumnEnum = {}));
/** Field to order the connection by */
var PostObjectsConnectionOrderbyEnum;
(function (PostObjectsConnectionOrderbyEnum) {
  /** Order by author */
  PostObjectsConnectionOrderbyEnum["Author"] = "AUTHOR";
  /** Order by the number of comments it has acquired */
  PostObjectsConnectionOrderbyEnum["CommentCount"] = "COMMENT_COUNT";
  /** Order by publish date */
  PostObjectsConnectionOrderbyEnum["Date"] = "DATE";
  /** Preserve the ID order given in the IN array */
  PostObjectsConnectionOrderbyEnum["In"] = "IN";
  /** Order by the menu order value */
  PostObjectsConnectionOrderbyEnum["MenuOrder"] = "MENU_ORDER";
  /** Order by last modified date */
  PostObjectsConnectionOrderbyEnum["Modified"] = "MODIFIED";
  /** Preserve slug order given in the NAME_IN array */
  PostObjectsConnectionOrderbyEnum["NameIn"] = "NAME_IN";
  /** Order by parent ID */
  PostObjectsConnectionOrderbyEnum["Parent"] = "PARENT";
  /** Order by slug */
  PostObjectsConnectionOrderbyEnum["Slug"] = "SLUG";
  /** Order by title */
  PostObjectsConnectionOrderbyEnum["Title"] = "TITLE";
})(PostObjectsConnectionOrderbyEnum || (PostObjectsConnectionOrderbyEnum = {}));
/** The status of the object. */
var PostStatusEnum;
(function (PostStatusEnum) {
  /** Objects with the acf-disabled status */
  PostStatusEnum["AcfDisabled"] = "ACF_DISABLED";
  /** Objects with the auto-draft status */
  PostStatusEnum["AutoDraft"] = "AUTO_DRAFT";
  /** Objects with the dp-rewrite-republish status */
  PostStatusEnum["DpRewriteRepublish"] = "DP_REWRITE_REPUBLISH";
  /** Objects with the draft status */
  PostStatusEnum["Draft"] = "DRAFT";
  /** Objects with the draft-revision status */
  PostStatusEnum["DraftRevision"] = "DRAFT_REVISION";
  /** Objects with the future status */
  PostStatusEnum["Future"] = "FUTURE";
  /** Objects with the future-revision status */
  PostStatusEnum["FutureRevision"] = "FUTURE_REVISION";
  /** Objects with the inherit status */
  PostStatusEnum["Inherit"] = "INHERIT";
  /** Objects with the pending status */
  PostStatusEnum["Pending"] = "PENDING";
  /** Objects with the pending-revision status */
  PostStatusEnum["PendingRevision"] = "PENDING_REVISION";
  /** Objects with the private status */
  PostStatusEnum["Private"] = "PRIVATE";
  /** Objects with the publish status */
  PostStatusEnum["Publish"] = "PUBLISH";
  /** Objects with the request-completed status */
  PostStatusEnum["RequestCompleted"] = "REQUEST_COMPLETED";
  /** Objects with the request-confirmed status */
  PostStatusEnum["RequestConfirmed"] = "REQUEST_CONFIRMED";
  /** Objects with the request-failed status */
  PostStatusEnum["RequestFailed"] = "REQUEST_FAILED";
  /** Objects with the request-pending status */
  PostStatusEnum["RequestPending"] = "REQUEST_PENDING";
  /** Objects with the trash status */
  PostStatusEnum["Trash"] = "TRASH";
  /** Objects with the wp_stream_disabled status */
  PostStatusEnum["WpStreamDisabled"] = "WP_STREAM_DISABLED";
  /** Objects with the wp_stream_enabled status */
  PostStatusEnum["WpStreamEnabled"] = "WP_STREAM_ENABLED";
})(PostStatusEnum || (PostStatusEnum = {}));
/** The logical relation between each item in the array when there are more than one. */
var RelationEnum;
(function (RelationEnum) {
  /** The logical AND condition returns true if both operands are true, otherwise, it returns false. */
  RelationEnum["And"] = "AND";
  /** The logical OR condition returns false if both operands are false, otherwise, it returns true. */
  RelationEnum["Or"] = "OR";
})(RelationEnum || (RelationEnum = {}));
/** The Type of Identifier used to fetch a single resource. Default is ID. */
var ReleaseIdType;
(function (ReleaseIdType) {
  /** Identify a resource by the Database ID. */
  ReleaseIdType["DatabaseId"] = "DATABASE_ID";
  /** Identify a resource by the (hashed) Global ID. */
  ReleaseIdType["Id"] = "ID";
  /** Identify a resource by the slug. Available to non-hierarchcial Types where the slug is a unique identifier. */
  ReleaseIdType["Slug"] = "SLUG";
  /** Identify a resource by the URI. */
  ReleaseIdType["Uri"] = "URI";
})(ReleaseIdType || (ReleaseIdType = {}));
/** The strategy to use when loading the script */
var ScriptLoadingStrategyEnum;
(function (ScriptLoadingStrategyEnum) {
  /** Use the script `async` attribute */
  ScriptLoadingStrategyEnum["Async"] = "ASYNC";
  /** Use the script `defer` attribute */
  ScriptLoadingStrategyEnum["Defer"] = "DEFER";
})(ScriptLoadingStrategyEnum || (ScriptLoadingStrategyEnum = {}));
/** The Type of Identifier used to fetch a single resource. Default is ID. */
var TagIdType;
(function (TagIdType) {
  /** The Database ID for the node */
  TagIdType["DatabaseId"] = "DATABASE_ID";
  /** The hashed Global ID */
  TagIdType["Id"] = "ID";
  /** The name of the node */
  TagIdType["Name"] = "NAME";
  /** Url friendly name of the node */
  TagIdType["Slug"] = "SLUG";
  /** The URI for the node */
  TagIdType["Uri"] = "URI";
})(TagIdType || (TagIdType = {}));
/** Allowed taxonomies */
var TaxonomyEnum;
(function (TaxonomyEnum) {
  /** Taxonomy enum category */
  TaxonomyEnum["Category"] = "CATEGORY";
  /** Taxonomy enum post_format */
  TaxonomyEnum["Postformat"] = "POSTFORMAT";
  /** Taxonomy enum post_tag */
  TaxonomyEnum["Tag"] = "TAG";
})(TaxonomyEnum || (TaxonomyEnum = {}));
/** The Type of Identifier used to fetch a single Taxonomy node. To be used along with the "id" field. Default is "ID". */
var TaxonomyIdTypeEnum;
(function (TaxonomyIdTypeEnum) {
  /** The globally unique ID */
  TaxonomyIdTypeEnum["Id"] = "ID";
  /** The name of the taxonomy */
  TaxonomyIdTypeEnum["Name"] = "NAME";
})(TaxonomyIdTypeEnum || (TaxonomyIdTypeEnum = {}));
/** Hae sivuobjekti sivupohjan mukaan */
var TemplateEnum;
(function (TemplateEnum) {
  TemplateEnum["FrontPage"] = "frontPage";
  TemplateEnum["PostsPage"] = "postsPage";
})(TemplateEnum || (TemplateEnum = {}));
/** The Type of Identifier used to fetch a single resource. Default is "ID". To be used along with the "id" field. */
var TermNodeIdTypeEnum;
(function (TermNodeIdTypeEnum) {
  /** The Database ID for the node */
  TermNodeIdTypeEnum["DatabaseId"] = "DATABASE_ID";
  /** The hashed Global ID */
  TermNodeIdTypeEnum["Id"] = "ID";
  /** The name of the node */
  TermNodeIdTypeEnum["Name"] = "NAME";
  /** Url friendly name of the node */
  TermNodeIdTypeEnum["Slug"] = "SLUG";
  /** The URI for the node */
  TermNodeIdTypeEnum["Uri"] = "URI";
})(TermNodeIdTypeEnum || (TermNodeIdTypeEnum = {}));
/** Options for ordering the connection by */
var TermObjectsConnectionOrderbyEnum;
(function (TermObjectsConnectionOrderbyEnum) {
  /** Order the connection by item count. */
  TermObjectsConnectionOrderbyEnum["Count"] = "COUNT";
  /** Order the connection by description. */
  TermObjectsConnectionOrderbyEnum["Description"] = "DESCRIPTION";
  /** Order the connection by name. */
  TermObjectsConnectionOrderbyEnum["Name"] = "NAME";
  /** Order the connection by slug. */
  TermObjectsConnectionOrderbyEnum["Slug"] = "SLUG";
  /** Order the connection by term group. */
  TermObjectsConnectionOrderbyEnum["TermGroup"] = "TERM_GROUP";
  /** Order the connection by term id. */
  TermObjectsConnectionOrderbyEnum["TermId"] = "TERM_ID";
  /** Order the connection by term order. */
  TermObjectsConnectionOrderbyEnum["TermOrder"] = "TERM_ORDER";
})(TermObjectsConnectionOrderbyEnum || (TermObjectsConnectionOrderbyEnum = {}));
/** The Type of Identifier used to fetch a single resource. Default is ID. */
var TranslationIdType;
(function (TranslationIdType) {
  /** Identify a resource by the Database ID. */
  TranslationIdType["DatabaseId"] = "DATABASE_ID";
  /** Identify a resource by the (hashed) Global ID. */
  TranslationIdType["Id"] = "ID";
  /** Identify a resource by the slug. Available to non-hierarchcial Types where the slug is a unique identifier. */
  TranslationIdType["Slug"] = "SLUG";
  /** Identify a resource by the URI. */
  TranslationIdType["Uri"] = "URI";
})(TranslationIdType || (TranslationIdType = {}));
/** The Type of Identifier used to fetch a single User node. To be used along with the "id" field. Default is "ID". */
var UserNodeIdTypeEnum;
(function (UserNodeIdTypeEnum) {
  /** The Database ID for the node */
  UserNodeIdTypeEnum["DatabaseId"] = "DATABASE_ID";
  /** The Email of the User */
  UserNodeIdTypeEnum["Email"] = "EMAIL";
  /** The hashed Global ID */
  UserNodeIdTypeEnum["Id"] = "ID";
  /** The slug of the User */
  UserNodeIdTypeEnum["Slug"] = "SLUG";
  /** The URI for the node */
  UserNodeIdTypeEnum["Uri"] = "URI";
  /** The username the User uses to login with */
  UserNodeIdTypeEnum["Username"] = "USERNAME";
})(UserNodeIdTypeEnum || (UserNodeIdTypeEnum = {}));
/** Names of available user roles */
var UserRoleEnum;
(function (UserRoleEnum) {
  /** User role with specific capabilities */
  UserRoleEnum["Administrator"] = "ADMINISTRATOR";
  /** User role with specific capabilities */
  UserRoleEnum["Author"] = "AUTHOR";
  /** User role with specific capabilities */
  UserRoleEnum["Contributor"] = "CONTRIBUTOR";
  /** User role with specific capabilities */
  UserRoleEnum["Editor"] = "EDITOR";
  /** User role with specific capabilities */
  UserRoleEnum["HeadlessCmsAdmin"] = "HEADLESS_CMS_ADMIN";
  /** User role with specific capabilities */
  UserRoleEnum["HeadlessCmsContributor"] = "HEADLESS_CMS_CONTRIBUTOR";
  /** User role with specific capabilities */
  UserRoleEnum["HeadlessCmsEditor"] = "HEADLESS_CMS_EDITOR";
  /** User role with specific capabilities */
  UserRoleEnum["HeadlessCmsViewer"] = "HEADLESS_CMS_VIEWER";
  /** User role with specific capabilities */
  UserRoleEnum["Revisor"] = "REVISOR";
  /** User role with specific capabilities */
  UserRoleEnum["Subscriber"] = "SUBSCRIBER";
})(UserRoleEnum || (UserRoleEnum = {}));
/** Field to order the connection by */
var UsersConnectionOrderbyEnum;
(function (UsersConnectionOrderbyEnum) {
  /** Order by display name */
  UsersConnectionOrderbyEnum["DisplayName"] = "DISPLAY_NAME";
  /** Order by email address */
  UsersConnectionOrderbyEnum["Email"] = "EMAIL";
  /** Order by login */
  UsersConnectionOrderbyEnum["Login"] = "LOGIN";
  /** Preserve the login order given in the LOGIN_IN array */
  UsersConnectionOrderbyEnum["LoginIn"] = "LOGIN_IN";
  /** Order by nice name */
  UsersConnectionOrderbyEnum["NiceName"] = "NICE_NAME";
  /** Preserve the nice name order given in the NICE_NAME_IN array */
  UsersConnectionOrderbyEnum["NiceNameIn"] = "NICE_NAME_IN";
  /** Order by registration date */
  UsersConnectionOrderbyEnum["Registered"] = "REGISTERED";
  /** Order by URL */
  UsersConnectionOrderbyEnum["Url"] = "URL";
})(UsersConnectionOrderbyEnum || (UsersConnectionOrderbyEnum = {}));
/** Column used for searching for users. */
var UsersConnectionSearchColumnEnum;
(function (UsersConnectionSearchColumnEnum) {
  /** The user's email address. */
  UsersConnectionSearchColumnEnum["Email"] = "EMAIL";
  /** The globally unique ID. */
  UsersConnectionSearchColumnEnum["Id"] = "ID";
  /** The username the User uses to login with. */
  UsersConnectionSearchColumnEnum["Login"] = "LOGIN";
  /** A URL-friendly name for the user. The default is the user's username. */
  UsersConnectionSearchColumnEnum["Nicename"] = "NICENAME";
  /** The URL of the user's website. */
  UsersConnectionSearchColumnEnum["Url"] = "URL";
})(UsersConnectionSearchColumnEnum || (UsersConnectionSearchColumnEnum = {}));
var CategoriesFragmentDoc = gql(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  fragment Categories on PostToCategoryConnection {\n    edges {\n      node {\n        id\n        name\n      }\n    }\n  }\n"])));
var SeoFragmentDoc = gql(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  fragment SEO on SEO {\n    title\n    description\n    openGraphTitle\n    openGraphDescription\n    openGraphType\n    twitterTitle\n    twitterDescription\n    canonicalUrl\n    socialImage {\n      mediaItemUrl\n    }\n  }\n"])));
var LanguageFragmentDoc = gql(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  fragment Language on Language {\n    code\n    id\n    locale\n    name\n    slug\n  }\n"])));
var LayoutLinkListFragmentDoc = gql(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  fragment LayoutLinkList on LayoutLinkList {\n    anchor\n    title\n    description\n    links {\n      target\n      title\n      url\n    }\n    __typename\n  }\n"])));
var LayoutArticlesFragmentDoc = gql(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  fragment LayoutArticles on LayoutArticles {\n    title\n    articles {\n      id\n      uri\n      slug\n      link\n      date\n      title\n      lead\n      featuredImage {\n        node {\n          altText\n          mediaItemUrl\n          large: sourceUrl(size: LARGE)\n          medium_large: sourceUrl(size: MEDIUM_LARGE)\n          medium: sourceUrl(size: MEDIUM)\n          thumbnail: sourceUrl(size: THUMBNAIL)\n        }\n      }\n      categories {\n        nodes {\n          name\n        }\n      }\n    }\n    showAllLink\n    __typename\n  }\n"])));
var LayoutPagesFragmentDoc = gql(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n  fragment LayoutPages on LayoutPages {\n    title\n    description\n    pages {\n      id\n      uri\n      slug\n      link\n      date\n      title\n      lead\n      featuredImage {\n        node {\n          altText\n          mediaItemUrl\n          large: sourceUrl(size: LARGE)\n          medium_large: sourceUrl(size: MEDIUM_LARGE)\n          medium: sourceUrl(size: MEDIUM)\n          thumbnail: sourceUrl(size: THUMBNAIL)\n        }\n      }\n    }\n    showAllLink\n    __typename\n  }\n"])));
var LayoutCardsFragmentDoc = gql(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n  fragment LayoutCards on LayoutCards {\n    cards {\n      backgroundColor\n      description\n      icon\n      link {\n        target\n        title\n        url\n      }\n      title\n    }\n    __typename\n  }\n"])));
var LayoutArticlesCarouselFragmentDoc = gql(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n  fragment LayoutArticlesCarousel on LayoutArticlesCarousel {\n    title\n    articles {\n      id\n      uri\n      slug\n      link\n      date\n      title\n      lead\n      featuredImage {\n        node {\n          altText\n          mediaItemUrl\n          large: sourceUrl(size: LARGE)\n          medium_large: sourceUrl(size: MEDIUM_LARGE)\n          medium: sourceUrl(size: MEDIUM)\n          thumbnail: sourceUrl(size: THUMBNAIL)\n        }\n      }\n      categories {\n        nodes {\n          name\n        }\n      }\n    }\n    showMore\n    showAllLink\n    __typename\n  }\n"])));
var LayoutPagesCarouselFragmentDoc = gql(_templateObject9 || (_templateObject9 = _taggedTemplateLiteral(["\n  fragment LayoutPagesCarousel on LayoutPagesCarousel {\n    title\n    description\n    pages {\n      id\n      uri\n      slug\n      link\n      date\n      title\n      lead\n      featuredImage {\n        node {\n          altText\n          mediaItemUrl\n          large: sourceUrl(size: LARGE)\n          medium_large: sourceUrl(size: MEDIUM_LARGE)\n          medium: sourceUrl(size: MEDIUM)\n          thumbnail: sourceUrl(size: THUMBNAIL)\n        }\n      }\n    }\n    __typename\n  }\n"])));
var EventSearchFragmentDoc = gql(_templateObject10 || (_templateObject10 = _taggedTemplateLiteral(["\n  fragment EventSearch on EventSearch {\n    title\n    url\n    module\n    showAllLink\n    showAllLinkCustom\n    __typename\n  }\n"])));
var EventSelectedFragmentDoc = gql(_templateObject11 || (_templateObject11 = _taggedTemplateLiteral(["\n  fragment EventSelected on EventSelected {\n    title\n    events\n    module\n    __typename\n  }\n"])));
var EventSearchCarouselFragmentDoc = gql(_templateObject12 || (_templateObject12 = _taggedTemplateLiteral(["\n  fragment EventSearchCarousel on EventSearchCarousel {\n    title\n    url\n    orderNewestFirst\n    eventsNearby\n    amountOfCards\n    showAllLink\n    showAllLinkCustom\n    __typename\n  }\n"])));
var EventSelectedCarouselFragmentDoc = gql(_templateObject13 || (_templateObject13 = _taggedTemplateLiteral(["\n  fragment EventSelectedCarousel on EventSelectedCarousel {\n    title\n    module\n    eventsNearby\n    events\n    amountOfCardsPerRow\n    amountOfCards\n    __typename\n  }\n"])));
var LayoutCollectionFragmentDoc = gql(_templateObject14 || (_templateObject14 = _taggedTemplateLiteral(["\n  fragment LayoutCollection on LayoutCollection {\n    collection {\n      title\n    }\n    __typename\n  }\n"])));
var LocationsSelectedFragmentDoc = gql(_templateObject15 || (_templateObject15 = _taggedTemplateLiteral(["\n  fragment LocationsSelected on LocationsSelected {\n    title\n    locations\n    module\n    __typename\n  }\n"])));
var LocationsSelectedCarouselFragmentDoc = gql(_templateObject16 || (_templateObject16 = _taggedTemplateLiteral(["\n  fragment LocationsSelectedCarousel on LocationsSelectedCarousel {\n    title\n    locations\n    module\n    __typename\n  }\n"])));
var LayoutContentFragmentDoc = gql(_templateObject17 || (_templateObject17 = _taggedTemplateLiteral(["\n  fragment LayoutContent on LayoutContent {\n    backgroundColor\n    content\n    title\n    __typename\n  }\n"])));
var LayoutCardFragmentDoc = gql(_templateObject18 || (_templateObject18 = _taggedTemplateLiteral(["\n  fragment LayoutCard on LayoutCard {\n    alignment\n    backgroundColor\n    description\n    link {\n      target\n      title\n      url\n    }\n    title\n    image {\n      caption\n      description\n      large\n      medium\n      medium_large\n      thumbnail\n      title\n    }\n    __typename\n  }\n"])));
var LayoutImageFragmentDoc = gql(_templateObject19 || (_templateObject19 = _taggedTemplateLiteral(["\n  fragment LayoutImage on LayoutImage {\n    border\n    photographer_name\n    image {\n      caption\n      description\n      large\n      medium_large\n      medium\n      thumbnail\n      title\n      medium_large\n    }\n    show_on_lightbox\n    __typename\n  }\n"])));
var LayoutImageGalleryFragmentDoc = gql(_templateObject20 || (_templateObject20 = _taggedTemplateLiteral(["\n  fragment LayoutImageGallery on LayoutImageGallery {\n    gallery {\n      caption\n      description\n      large\n      medium_large\n      medium\n      thumbnail\n      title\n      medium_large\n    }\n    __typename\n  }\n"])));
var LayoutStepsFragmentDoc = gql(_templateObject21 || (_templateObject21 = _taggedTemplateLiteral(["\n  fragment LayoutSteps on LayoutSteps {\n    color\n    description\n    steps {\n      content\n      title\n    }\n    title\n    type\n    __typename\n  }\n"])));
var LayoutSocialMediaFeedFragmentDoc = gql(_templateObject22 || (_templateObject22 = _taggedTemplateLiteral(["\n  fragment LayoutSocialMediaFeed on LayoutSocialMediaFeed {\n    anchor\n    script\n    title\n    __typename\n  }\n"])));
var PostFragmentDoc = gql(_templateObject23 || (_templateObject23 = _taggedTemplateLiteral(["\n  fragment Post on Post {\n    id\n    date\n    content\n    slug\n    title\n    uri\n    link\n    lead\n    categories {\n      ...Categories\n    }\n    seo {\n      ...SEO\n    }\n    language {\n      ...Language\n    }\n    translations {\n      uri\n      slug\n      language {\n        ...Language\n      }\n      seo {\n        ...SEO\n      }\n    }\n    featuredImage {\n      node {\n        mediaItemUrl\n        link\n        altText\n        mimeType\n        title\n        uri\n        photographerName\n        large: sourceUrl(size: LARGE)\n        medium_large: sourceUrl(size: MEDIUM_LARGE)\n        medium: sourceUrl(size: MEDIUM)\n        thumbnail: sourceUrl(size: THUMBNAIL)\n      }\n    }\n    breadcrumbs {\n      title\n      uri\n    }\n    sidebar {\n      ... on LayoutLinkList {\n        ...LayoutLinkList\n      }\n      ... on LayoutArticles {\n        ...LayoutArticles\n      }\n      ... on LayoutPages {\n        ...LayoutPages\n      }\n      ... on LayoutCards {\n        ...LayoutCards\n      }\n    }\n    modules {\n      ... on LayoutArticles {\n        ...LayoutArticles\n      }\n      ... on LayoutArticlesCarousel {\n        ...LayoutArticlesCarousel\n      }\n      ... on LayoutPages {\n        ...LayoutPages\n      }\n      ... on LayoutPagesCarousel {\n        ...LayoutPagesCarousel\n      }\n      ... on LayoutArticles {\n        ...LayoutArticles\n      }\n      ... on LayoutArticlesCarousel {\n        ...LayoutArticlesCarousel\n      }\n      ... on LayoutPages {\n        ...LayoutPages\n      }\n      ... on LayoutPagesCarousel {\n        ...LayoutPagesCarousel\n      }\n      ... on EventSearch {\n        ...EventSearch\n      }\n      ... on EventSelected {\n        ...EventSelected\n      }\n      ... on EventSearchCarousel {\n        ...EventSearchCarousel\n      }\n      ... on EventSelectedCarousel {\n        ...EventSelectedCarousel\n      }\n      ... on LayoutCollection {\n        ...LayoutCollection\n      }\n      ... on LocationsSelected {\n        ...LocationsSelected\n      }\n      ... on LocationsSelectedCarousel {\n        ...LocationsSelectedCarousel\n      }\n      ... on LayoutContent {\n        ...LayoutContent\n      }\n      ... on LayoutCard {\n        ...LayoutCard\n      }\n      ... on LayoutCards {\n        ...LayoutCards\n      }\n      ... on LayoutImage {\n        ...LayoutImage\n      }\n      ... on LayoutImageGallery {\n        ...LayoutImageGallery\n      }\n      ... on LayoutSteps {\n        ...LayoutSteps\n      }\n      ... on LayoutSocialMediaFeed {\n        ...LayoutSocialMediaFeed\n      }\n    }\n  }\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n"])), CategoriesFragmentDoc, SeoFragmentDoc, LanguageFragmentDoc, LayoutLinkListFragmentDoc, LayoutArticlesFragmentDoc, LayoutPagesFragmentDoc, LayoutCardsFragmentDoc, LayoutArticlesCarouselFragmentDoc, LayoutPagesCarouselFragmentDoc, EventSearchFragmentDoc, EventSelectedFragmentDoc, EventSearchCarouselFragmentDoc, EventSelectedCarouselFragmentDoc, LayoutCollectionFragmentDoc, LocationsSelectedFragmentDoc, LocationsSelectedCarouselFragmentDoc, LayoutContentFragmentDoc, LayoutCardFragmentDoc, LayoutImageFragmentDoc, LayoutImageGalleryFragmentDoc, LayoutStepsFragmentDoc, LayoutSocialMediaFeedFragmentDoc);
var PageFragmentDoc = gql(_templateObject24 || (_templateObject24 = _taggedTemplateLiteral(["\n  fragment Page on Page {\n    id\n    content\n    slug\n    title\n    uri\n    link\n    lead\n    seo {\n      ...SEO\n    }\n    hero {\n      background_color\n      background_image_url\n      description\n      link {\n        target\n        title\n        url\n      }\n      title\n      wave_motif\n    }\n    language {\n      ...Language\n    }\n    translations {\n      uri\n      slug\n      language {\n        ...Language\n      }\n      seo {\n        ...SEO\n      }\n    }\n    featuredImage {\n      node {\n        mediaItemUrl\n        link\n        altText\n        mimeType\n        title\n        uri\n        photographerName\n        large: sourceUrl(size: LARGE)\n        medium_large: sourceUrl(size: MEDIUM_LARGE)\n        medium: sourceUrl(size: MEDIUM)\n        thumbnail: sourceUrl(size: THUMBNAIL)\n      }\n    }\n    breadcrumbs {\n      title\n      uri\n    }\n    sidebar {\n      ... on LayoutLinkList {\n        ...LayoutLinkList\n      }\n      ... on LayoutArticles {\n        ...LayoutArticles\n      }\n      ... on LayoutPages {\n        ...LayoutPages\n      }\n      ... on LayoutCards {\n        ...LayoutCards\n      }\n    }\n    modules {\n      ... on LayoutArticles {\n        ...LayoutArticles\n      }\n      ... on LayoutArticlesCarousel {\n        ...LayoutArticlesCarousel\n      }\n      ... on LayoutPages {\n        ...LayoutPages\n      }\n      ... on LayoutPagesCarousel {\n        ...LayoutPagesCarousel\n      }\n      ... on EventSearch {\n        ...EventSearch\n      }\n      ... on EventSelected {\n        ...EventSelected\n      }\n      ... on EventSearchCarousel {\n        ...EventSearchCarousel\n      }\n      ... on EventSelectedCarousel {\n        ...EventSelectedCarousel\n      }\n      ... on LayoutCollection {\n        ...LayoutCollection\n      }\n      ... on LocationsSelected {\n        ...LocationsSelected\n      }\n      ... on LocationsSelectedCarousel {\n        ...LocationsSelectedCarousel\n      }\n      ... on LayoutContent {\n        ...LayoutContent\n      }\n      ... on LayoutCard {\n        ...LayoutCard\n      }\n      ... on LayoutCards {\n        ...LayoutCards\n      }\n      ... on LayoutImage {\n        ...LayoutImage\n      }\n      ... on LayoutImageGallery {\n        ...LayoutImageGallery\n      }\n      ... on LayoutSteps {\n        ...LayoutSteps\n      }\n      ... on LayoutSocialMediaFeed {\n        ...LayoutSocialMediaFeed\n      }\n    }\n  }\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n"])), SeoFragmentDoc, LanguageFragmentDoc, LayoutLinkListFragmentDoc, LayoutArticlesFragmentDoc, LayoutPagesFragmentDoc, LayoutCardsFragmentDoc, LayoutArticlesCarouselFragmentDoc, LayoutPagesCarouselFragmentDoc, EventSearchFragmentDoc, EventSelectedFragmentDoc, EventSearchCarouselFragmentDoc, EventSelectedCarouselFragmentDoc, LayoutCollectionFragmentDoc, LocationsSelectedFragmentDoc, LocationsSelectedCarouselFragmentDoc, LayoutContentFragmentDoc, LayoutCardFragmentDoc, LayoutImageFragmentDoc, LayoutImageGalleryFragmentDoc, LayoutStepsFragmentDoc, LayoutSocialMediaFeedFragmentDoc);
var MenuPageFieldsFragmentDoc = gql(_templateObject25 || (_templateObject25 = _taggedTemplateLiteral(["\n  fragment menuPageFields on Page {\n    ...Page\n    translations {\n      ...Page\n    }\n  }\n  ", "\n"])), PageFragmentDoc);
var MenuPageIdentifierFieldsFragmentDoc = gql(_templateObject26 || (_templateObject26 = _taggedTemplateLiteral(["\n  fragment menuPageIdentifierFields on Page {\n    id\n    uri\n    slug\n    parentId\n    title\n  }\n"])));
var MenuPageIdentifiersFragmentDoc = gql(_templateObject27 || (_templateObject27 = _taggedTemplateLiteral(["\n  fragment menuPageIdentifiers on Page {\n    ...menuPageIdentifierFields\n    translations {\n      ...menuPageIdentifierFields\n    }\n  }\n  ", "\n"])), MenuPageIdentifierFieldsFragmentDoc);
var MenuItemFragmentDoc = gql(_templateObject28 || (_templateObject28 = _taggedTemplateLiteral(["\n  fragment MenuItem on MenuItem {\n    id\n    parentId\n    order\n    target\n    title\n    path\n    label\n    connectedNode {\n      node {\n        ... on Page {\n          ...menuPageFields @skip(if: $menuIdentifiersOnly)\n          ...menuPageIdentifiers @include(if: $menuIdentifiersOnly)\n          children {\n            nodes {\n              ...menuPageFields @skip(if: $menuIdentifiersOnly)\n              ...menuPageIdentifiers @include(if: $menuIdentifiersOnly)\n            }\n          }\n        }\n      }\n    }\n  }\n  ", "\n  ", "\n"])), MenuPageFieldsFragmentDoc, MenuPageIdentifiersFragmentDoc);
gql(_templateObject29 || (_templateObject29 = _taggedTemplateLiteral(["\n  fragment LayoutArticleHighlights on LayoutArticleHighlights {\n    __typename\n  }\n"])));
gql(_templateObject30 || (_templateObject30 = _taggedTemplateLiteral(["\n  fragment LayoutContact on LayoutContact {\n    __typename\n  }\n"])));
var ArticleDocument = gql(_templateObject31 || (_templateObject31 = _taggedTemplateLiteral(["\n  query article($id: ID!) {\n    post(id: $id, idType: URI) {\n      ...Post\n    }\n  }\n  ", "\n"])), PostFragmentDoc);
/**
 * __useArticleQuery__
 *
 * To run a query within a React component, call `useArticleQuery` and pass it any options that fit your needs.
 * When your component renders, `useArticleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useArticleQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
function useArticleQuery(baseOptions) {
  var options = _objectSpread2(_objectSpread2({}, defaultOptions), baseOptions);
  return Apollo.useQuery(ArticleDocument, options);
}
var PostsDocument = gql(_templateObject32 || (_templateObject32 = _taggedTemplateLiteral(["\n  query posts(\n    $first: Int\n    $after: String\n    $search: String\n    $language: LanguageCodeFilterEnum\n    $categories: [ID]\n    $tags: [String]\n  ) {\n    posts(\n      first: $first\n      after: $after\n      where: {\n        search: $search\n        language: $language\n        categoryIn: $categories\n        tagSlugIn: $tags\n      }\n    ) {\n      pageInfo {\n        endCursor\n        hasNextPage\n        hasPreviousPage\n        startCursor\n      }\n      edges {\n        cursor\n        node {\n          ...Post\n        }\n      }\n    }\n  }\n  ", "\n"])), PostFragmentDoc);
/**
 * __usePostsQuery__
 *
 * To run a query within a React component, call `usePostsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePostsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePostsQuery({
 *   variables: {
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      search: // value for 'search'
 *      language: // value for 'language'
 *      categories: // value for 'categories'
 *      tags: // value for 'tags'
 *   },
 * });
 */
function usePostsQuery(baseOptions) {
  var options = _objectSpread2(_objectSpread2({}, defaultOptions), baseOptions);
  return Apollo.useQuery(PostsDocument, options);
}
var CategoriesDocument = gql(_templateObject33 || (_templateObject33 = _taggedTemplateLiteral(["\n  query categories(\n    $first: Int\n    $after: String\n    $search: String\n    $language: LanguageCodeFilterEnum\n  ) {\n    categories(\n      first: $first\n      after: $after\n      where: { language: $language, search: $search }\n    ) {\n      nodes {\n        id\n        databaseId\n        name\n        slug\n        uri\n        translations {\n          name\n          slug\n          uri\n          language {\n            ...Language\n          }\n        }\n        __typename\n      }\n    }\n  }\n  ", "\n"])), LanguageFragmentDoc);
/**
 * __useCategoriesQuery__
 *
 * To run a query within a React component, call `useCategoriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useCategoriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCategoriesQuery({
 *   variables: {
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      search: // value for 'search'
 *      language: // value for 'language'
 *   },
 * });
 */
function useCategoriesQuery(baseOptions) {
  var options = _objectSpread2(_objectSpread2({}, defaultOptions), baseOptions);
  return Apollo.useQuery(CategoriesDocument, options);
}
var CategoryDocument = gql(_templateObject34 || (_templateObject34 = _taggedTemplateLiteral(["\n  query category($id: ID!, $language: LanguageCodeEnum!) {\n    category(id: $id, idType: SLUG) {\n      id\n      databaseId\n      name\n      slug\n      translation(language: $language) {\n        name\n        slug\n        language {\n          ...Language\n        }\n      }\n      __typename\n    }\n  }\n  ", "\n"])), LanguageFragmentDoc);
/**
 * __useCategoryQuery__
 *
 * To run a query within a React component, call `useCategoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useCategoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCategoryQuery({
 *   variables: {
 *      id: // value for 'id'
 *      language: // value for 'language'
 *   },
 * });
 */
function useCategoryQuery(baseOptions) {
  var options = _objectSpread2(_objectSpread2({}, defaultOptions), baseOptions);
  return Apollo.useQuery(CategoryDocument, options);
}
var LandingPageDocument = gql(_templateObject35 || (_templateObject35 = _taggedTemplateLiteral(["\n  query landingPage($id: ID!, $languageCode: LanguageCodeEnum!) {\n    landingPage(id: $id, idType: SLUG) {\n      id\n      desktopImage {\n        edges {\n          node {\n            mediaItemUrl\n          }\n        }\n      }\n      translation(language: $languageCode) {\n        title\n        description\n        heroLink\n      }\n    }\n  }\n"])));
/**
 * __useLandingPageQuery__
 *
 * To run a query within a React component, call `useLandingPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useLandingPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLandingPageQuery({
 *   variables: {
 *      id: // value for 'id'
 *      languageCode: // value for 'languageCode'
 *   },
 * });
 */
function useLandingPageQuery(baseOptions) {
  var options = _objectSpread2(_objectSpread2({}, defaultOptions), baseOptions);
  return Apollo.useQuery(LandingPageDocument, options);
}
var LanguagesDocument = gql(_templateObject36 || (_templateObject36 = _taggedTemplateLiteral(["\n  query languages {\n    languages {\n      ...Language\n    }\n  }\n  ", "\n"])), LanguageFragmentDoc);
/**
 * __useLanguagesQuery__
 *
 * To run a query within a React component, call `useLanguagesQuery` and pass it any options that fit your needs.
 * When your component renders, `useLanguagesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLanguagesQuery({
 *   variables: {
 *   },
 * });
 */
function useLanguagesQuery(baseOptions) {
  var options = _objectSpread2(_objectSpread2({}, defaultOptions), baseOptions);
  return Apollo.useQuery(LanguagesDocument, options);
}
var MenuDocument = gql(_templateObject37 || (_templateObject37 = _taggedTemplateLiteral(["\n  query menu($id: ID!, $menuIdentifiersOnly: Boolean = false) {\n    menu(idType: NAME, id: $id) {\n      id\n      menuItems(first: 100) {\n        nodes {\n          ...MenuItem\n        }\n      }\n    }\n  }\n  ", "\n"])), MenuItemFragmentDoc);
/**
 * __useMenuQuery__
 *
 * To run a query within a React component, call `useMenuQuery` and pass it any options that fit your needs.
 * When your component renders, `useMenuQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMenuQuery({
 *   variables: {
 *      id: // value for 'id'
 *      menuIdentifiersOnly: // value for 'menuIdentifiersOnly'
 *   },
 * });
 */
function useMenuQuery(baseOptions) {
  var options = _objectSpread2(_objectSpread2({}, defaultOptions), baseOptions);
  return Apollo.useQuery(MenuDocument, options);
}
var NotificationDocument = gql(_templateObject38 || (_templateObject38 = _taggedTemplateLiteral(["\n  query notification($language: String! = \"fi\") {\n    notification(language: $language) {\n      content\n      title\n      level\n      startDate\n      endDate\n      linkText\n      linkUrl\n    }\n  }\n"])));
/**
 * __useNotificationQuery__
 *
 * To run a query within a React component, call `useNotificationQuery` and pass it any options that fit your needs.
 * When your component renders, `useNotificationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNotificationQuery({
 *   variables: {
 *      language: // value for 'language'
 *   },
 * });
 */
function useNotificationQuery(baseOptions) {
  var options = _objectSpread2(_objectSpread2({}, defaultOptions), baseOptions);
  return Apollo.useQuery(NotificationDocument, options);
}
var PageDocument = gql(_templateObject39 || (_templateObject39 = _taggedTemplateLiteral(["\n  query page($id: ID!) {\n    page(id: $id, idType: URI) {\n      ...Page\n    }\n  }\n  ", "\n"])), PageFragmentDoc);
/**
 * __usePageQuery__
 *
 * To run a query within a React component, call `usePageQuery` and pass it any options that fit your needs.
 * When your component renders, `usePageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePageQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
function usePageQuery(baseOptions) {
  var options = _objectSpread2(_objectSpread2({}, defaultOptions), baseOptions);
  return Apollo.useQuery(PageDocument, options);
}
var PageByTemplateDocument = gql(_templateObject40 || (_templateObject40 = _taggedTemplateLiteral(["\n  query pageByTemplate($template: TemplateEnum, $language: String) {\n    pageByTemplate(template: $template, language: $language) {\n      ...Page\n    }\n  }\n  ", "\n"])), PageFragmentDoc);
/**
 * __usePageByTemplateQuery__
 *
 * To run a query within a React component, call `usePageByTemplateQuery` and pass it any options that fit your needs.
 * When your component renders, `usePageByTemplateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePageByTemplateQuery({
 *   variables: {
 *      template: // value for 'template'
 *      language: // value for 'language'
 *   },
 * });
 */
function usePageByTemplateQuery(baseOptions) {
  var options = _objectSpread2(_objectSpread2({}, defaultOptions), baseOptions);
  return Apollo.useQuery(PageByTemplateDocument, options);
}
gql(_templateObject41 || (_templateObject41 = _taggedTemplateLiteral(["\n  query PageChildrenSearch(\n    $id: ID!\n    $idType: PageIdType\n    $search: String!\n    $first: Int\n    $after: String\n  ) {\n    page(id: $id, idType: $idType) {\n      id\n      children(where: { search: $search }, first: $first, after: $after) {\n        pageInfo {\n          endCursor\n          hasNextPage\n        }\n        edges {\n          cursor\n          node {\n            ... on Page {\n              ...Page\n              translations {\n                ...Page\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n  ", "\n"])), PageFragmentDoc);
var PagesDocument = gql(_templateObject42 || (_templateObject42 = _taggedTemplateLiteral(["\n  query pages(\n    $first: Int\n    $after: String\n    $search: String\n    $language: LanguageCodeFilterEnum\n  ) {\n    pages(\n      first: $first\n      after: $after\n      where: { search: $search, language: $language }\n    ) {\n      pageInfo {\n        endCursor\n        hasNextPage\n        hasPreviousPage\n        startCursor\n      }\n      edges {\n        cursor\n        node {\n          ...Page\n        }\n      }\n    }\n  }\n  ", "\n"])), PageFragmentDoc);
/**
 * __usePagesQuery__
 *
 * To run a query within a React component, call `usePagesQuery` and pass it any options that fit your needs.
 * When your component renders, `usePagesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePagesQuery({
 *   variables: {
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      search: // value for 'search'
 *      language: // value for 'language'
 *   },
 * });
 */
function usePagesQuery(baseOptions) {
  var options = _objectSpread2(_objectSpread2({}, defaultOptions), baseOptions);
  return Apollo.useQuery(PagesDocument, options);
}
var TagDocument = gql(_templateObject43 || (_templateObject43 = _taggedTemplateLiteral(["\n  query tag($id: ID!, $language: LanguageCodeEnum!) {\n    tag(id: $id, idType: SLUG) {\n      id\n      databaseId\n      name\n      slug\n      translation(language: $language) {\n        name\n        slug\n        language {\n          ...Language\n        }\n      }\n      __typename\n    }\n  }\n  ", "\n"])), LanguageFragmentDoc);
/**
 * __useTagQuery__
 *
 * To run a query within a React component, call `useTagQuery` and pass it any options that fit your needs.
 * When your component renders, `useTagQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTagQuery({
 *   variables: {
 *      id: // value for 'id'
 *      language: // value for 'language'
 *   },
 * });
 */
function useTagQuery(baseOptions) {
  var options = _objectSpread2(_objectSpread2({}, defaultOptions), baseOptions);
  return Apollo.useQuery(TagDocument, options);
}
var TagsDocument = gql(_templateObject44 || (_templateObject44 = _taggedTemplateLiteral(["\n  query tags(\n    $first: Int\n    $after: String\n    $search: String\n    $language: LanguageCodeFilterEnum\n  ) {\n    tags(\n      first: $first\n      after: $after\n      where: { language: $language, search: $search }\n    ) {\n      nodes {\n        id\n        databaseId\n        name\n        slug\n        translations {\n          name\n          slug\n          uri\n          language {\n            ...Language\n          }\n        }\n        __typename\n      }\n    }\n  }\n  ", "\n"])), LanguageFragmentDoc);
/**
 * __useTagsQuery__
 *
 * To run a query within a React component, call `useTagsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTagsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTagsQuery({
 *   variables: {
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      search: // value for 'search'
 *      language: // value for 'language'
 *   },
 * });
 */
function useTagsQuery(baseOptions) {
  var options = _objectSpread2(_objectSpread2({}, defaultOptions), baseOptions);
  return Apollo.useQuery(TagsDocument, options);
}

export { ArticleDocument as A, TagDocument as B, CategoryDocument as C, TagsDocument as D, LandingPageDocument as E, PageByTemplateDocument as F, _typeof as G, _taggedTemplateLiteral as H, LanguagesDocument as L, MenuDocument as M, PageDocument as P, TemplateEnum as T, _asyncToGenerator as _, _regeneratorRuntime as a, _objectSpread2 as b, _objectWithoutProperties as c, _slicedToArray as d, _toConsumableArray as e, PageIdType as f, LanguageCodeEnum as g, LanguageCodeFilterEnum as h, MenuNodeIdTypeEnum as i, useMenuQuery as j, useNotificationQuery as k, _defineProperty as l, usePageQuery as m, usePageByTemplateQuery as n, usePagesQuery as o, useArticleQuery as p, usePostsQuery as q, useCategoryQuery as r, useCategoriesQuery as s, useTagQuery as t, useLanguagesQuery as u, useTagsQuery as v, useLandingPageQuery as w, PagesDocument as x, PostsDocument as y, CategoriesDocument as z };
